'use client';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = (theme, errorCTA) => ({
  text: {
    p: 0,
    background: 'none',
    color: theme?.palette?.button?.text?.textColor,
    '&:hover': {
      background: 'transparent',
      color: theme?.palette?.button?.text?.textHoverColor,
    },
  },
  outlined: {
    background: theme?.palette?.button?.outlined?.background,
    border: `0.1875rem solid ${theme?.palette?.button?.outlined?.backgroundHover}`,
    color: theme?.palette?.button?.outlined?.textColor,
    '&:hover': {
      background: theme?.palette?.button?.outlined?.backgroundHover,
      color: theme?.palette?.button?.outlined?.textHoverColor,
      border: `0.1875rem solid ${theme?.palette?.button?.outlined?.backgroundHover}`,
    },
  },
  contained: {
    p: errorCTA && '0.4rem 6.5rem',
    background: theme?.palette?.button?.contained?.background,
    border: `0.063rem solid ${theme?.palette?.button?.contained?.border}`,
    color: theme?.palette?.button?.contained?.textColor,
    '&:hover': {
      background: theme?.palette?.button?.contained?.backgroundHover,
      color: theme?.palette?.button?.contained?.textHoverColor,
      border: `0.063rem solid ${theme?.palette?.button?.contained?.border}`,
    },
  },
});
